import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-item: center;
  justify-content: space-between;
`;

export const Frame = styled.div``;

export const SubHeading = styled.p`
  margin: 0;
  font-family: NunitoSans-SemiBold;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;
  letter-spacing: 0.5px;
  color: #4f4f4f;
  @media (max-width: 1024px) {
    text-align: left;
  }
  @media (max-width: 600px) {
    text-align: left;
    font-size: 14px;
    line-height: 20px;
  }
`;

export const Heading = styled.h2`
  margin: 0;
  font-family: NunitoSans-Bold;
  font-style: normal;
  font-weight: bold;
  font-size: 30px;
  line-height: 60px;
  letter-spacing: 1.5px;
  margin-bottom: 20px;
  color: #000000;

  @media (max-width: 1024px) {
    margin-bottom: 28px;
    text-align: left;
  }
  @media (max-width: 600px) {
    margin-top: 11px;
    text-align: left;
    font-size: 24px;
    line-height: 32px;
    margin-bottom: 0px;
  }
`;

export const Text = styled.p`
  margin: 0;
  font-family: NunitoSans-Regular;
  font-style: normal;
  font-size: 16px;
  line-height: 30px;
  letter-spacing: 0.5px;
  color: #4f4f4f;
  font-weight: 400;

  @media (max-width: 1024px) {
    text-align: left;
  }

  @media (max-width: 600px) {
    margin-top: 24px;
    text-align: left;
    font-size: 12px;
    line-height: 20px;
  }
`;

export const Image = styled.img`
  width: 702px;
  height: 595px;
  margin-top: -70px;
  @media (max-width: 1024px) {
    width: 402px;
    height: 395px;
  }
  @media (max-width: 768px) {
    display: none;
  }
`;

export const Pane = styled.div`
  display: flex;
  align-items: center;
  width: 50%;
  @media (max-width: 1000px) {
    width: 100%;
    padding: 0 20px;
  }
  @media (max-width: 600px) {
    padding: unset;
    padding-left: 35px;
  }
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 91px 0 136px;

  @media (max-width: 1024px) {
    margin: 24px 45px;
  }
  @media (max-width: 600px) {
    margin: 0px;
  }
`;
